import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Merchantprofile = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        'https://api.bakpoket.com/api/AdminUsers/Merchants'
      );



      const data = res.data.data || res.data;
      setUsers(data);

    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  return (
    <div>
      <h2>Admin Users</h2>
  
 <div className="table-responsive">
    <table border="1" cellPadding="10">
  <thead>
    <tr>
      <th>ID</th>
      <th>Merchant Name</th>
      <th>Brand</th>
      <th>Industry</th>
      <th>Category</th>
      <th>Address</th>
      <th>Email</th>
      <th>Mobile</th>
      <th>Username</th>
      <th>merchatSiteUrl</th>
            <th>userName</th>
                  <th>password</th>
                        <th>passwordResetToken</th>
                              <th>referredByCode</th>
                                    <th>referralCode</th>
                                              <th>Email Status</th>
              <th>Registered</th>
    </tr>
  </thead>

  <tbody>
    {users.length === 0 ? (
      <tr>
        <td colSpan="6">No Data Found</td>
      </tr>
    ) : (
      users.map((user) => (
        <tr key={user.id}>
          <td>{user.id}</td>
          <td>{user.merchantName}</td>
          <td>{user.brandName}</td>
          <td>{user.industry}</td>
          <td>{user.category}</td>
          <td>{user.address}</td>
          <td>{user.email}</td>
          <td>{user.mobile}</td>
          <td>{user.userName}</td>
          <td>{user.merchatSiteUrl}</td>
         <td>{user.userName}</td>
         <td>{user.password}</td>
          <td>{user.passwordResetToken}</td>
                    <td>{user.referredByCode}</td>
                       <td>{user.referralCode}</td>
                        <td>
                    {user.isEmailConfirmed ? '✅ Verified' : '❌ Not Verified'}
                  </td>
                  <td>
                    {new Date(user.registeredOn).toLocaleDateString()}
                  </td>
        </tr>
      ))
    )}
  </tbody>
</table>
    </div></div>
  );
};

export default Merchantprofile;

